(() => {
  if (customElements.get('cdlr-rating-loader')) return;
  customElements.define('cdlr-rating-loader', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.observer) return;
        const rating = this.querySelector('[data-ac-product-rating]');
        if (!rating) { this.finish('error'); return; }
        const sync = () => {
          // These changes are emitted by AfterClient after its summary response.
          if (!rating.hidden && rating.querySelector('.ac-product-rating__count')) {
            this.finish('ready');
          } else if (rating.hidden && !rating.hasAttribute('aria-label')) {
            this.finish('empty');
          }
        };
        this.observer = new MutationObserver(sync);
        this.observer.observe(rating, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-label'] });
        sync();
        if (this.dataset.state === 'loading') {
          // The app aborts its request at 12 seconds; don't leave an endless skeleton on failures.
          this.timer = setTimeout(() => this.finish('error'), 15000);
        }
      });
    }
    finish(state) {
      clearTimeout(this.timer);
      this.dataset.state = state;
      this.setAttribute('aria-busy', 'false');
      this.closest('.product-info__block-item')?.classList.toggle('cdlr-rating-empty', state === 'empty' || state === 'error');
      const status = this.querySelector('[data-rating-loading-status]');
      if (status) status.textContent = state === 'error' ? 'Não foi possível carregar as avaliações.' : '';
      // Keep listening after errors so a late successful response can still reveal the native block.
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.observer = null;
    }
  });
})();
